// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "SellersProducts") return "AM/assets/styles/chunks/SellersProducts.b0cbe43a.css";
	if (chunkId === "ProductEdit") return "AM/assets/styles/chunks/ProductEdit.0dfe9fd7.css";
	// return url for filenames based on template
	return undefined;
};